import { SavePartyMutation37kzgcr2r74ko as SavePartyMutation } from './schema/SavePartyMutation.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Accepted_instance1051nmidder43 as Accepted_instance } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/CommandResult.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Dispatcher396y2mcz9r128 as Dispatcher } from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/party/SavePartyCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Companion_instance31yew3aywi0is as Companion_instance } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { Companion_instancen08xrtenlogm as Companion_instance_0 } from '../../../../../Coupling-libraries-model/com/zegreatrob/coupling/model/party/PairingRule.mjs';
import { SavePartyInput3ikp23en56cie as SavePartyInput } from './schema/type/SavePartyInput.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_perform__v6ng8j($this, command, $completion) {
  var tmp = $this.o6q(new (SavePartyMutation())(savePartyInput(command.m2l_1)), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Accepted_instance;
}
function perform(command, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_perform__v6ng8j.bind(VOID, this, command), $completion);
}
var SdkSavePartyCommandDispatcherClass;
function SdkSavePartyCommandDispatcher() {
  if (SdkSavePartyCommandDispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkSavePartyCommandDispatcher', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkSavePartyCommandDispatcherClass = $;
  }
  return SdkSavePartyCommandDispatcherClass;
}
function savePartyInput(_this__u8e3s4) {
  return new (SavePartyInput())(_this__u8e3s4.f2d_1, Companion_instance.q47(_this__u8e3s4.l2d_1), Companion_instance.q47(_this__u8e3s4.k2d_1), Companion_instance.q47(Companion_instance_0.e2d(_this__u8e3s4.g2d_1)), Companion_instance.q47(_this__u8e3s4.h2d_1), Companion_instance.q47(_this__u8e3s4.i2d_1), Companion_instance.q47(_this__u8e3s4.j2d_1), Companion_instance.q47(_this__u8e3s4.m2d_1), Companion_instance.q47(_this__u8e3s4.n2d_1), Companion_instance.q47(_this__u8e3s4.o2d_1));
}
//region block: exports
export {
  SdkSavePartyCommandDispatcher as SdkSavePartyCommandDispatcher1x5cidvmu3vb0,
  perform as perform1fdolsk5zjf2x,
};
//endregion

//# sourceMappingURL=SdkSavePartyCommandDispatcher.mjs.map
